import './index.styles.scss';
import logo from './assets/mini-logo.png';
import liliani from './assets/liliani.png';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';

export const MainView = () => {
  const navigate = useNavigate();
  return (
    <div className="main-page">
      <div className="logo">
        <div className="flex flex-col text-white h-full justify-center items-center gap-5">
          <div className="flex items-center flex-col gap-4">
            <div className="flex items-center font-bold text-4xl gap-3">
              <img src={logo} alt="logo" />
              Конфигуратор
            </div>
            <div className="flex items-center text-base gap-3">
              powered by
              <img src={liliani} alt="Liliani" />
            </div>
          </div>
          <div className="flex flex-col items-center text-base">
            <div>
              сервис по подбору модификаций сельскохозяйственной техники ООО “Лилиани”
            </div>
            <div>и дополнительных опций к ней</div>
          </div>
          <div className="flex text-black flex-row gap-6 flex-wrap justify-center">
            <button
              type="button"
              onClick={() => {
                // TODO: заменить на переход в Подборщик модели (внешний сервис), когда будет готов
                message.info('Подборщик модели появится позже');
              }}
              className="flex flex-col items-start text-left w-[460px] min-h-[220px] rounded-[16px] bg-white p-8 gap-4 cursor-pointer hover:opacity-90 transition">
              <span className="text-3xl font-bold">Подобрать модель бункера</span>
              <span className="text-base font-normal text-[#5a5a5a]">
                Выбрав этот вариант, Вы перейдёте в пошаговый Подборщик, который
                поможет корректно подобрать бункер-перегрузчик под Ваши комбайны и
                поля
              </span>
            </button>
            <button
              type="button"
              onClick={() => navigate('/configurator')}
              className="flex flex-col items-start text-left w-[460px] min-h-[220px] rounded-[16px] bg-white p-8 gap-4 cursor-pointer hover:opacity-90 transition">
              <span className="text-3xl font-bold">Сразу в конфигуратор опций</span>
              <span className="text-base font-normal text-[#5a5a5a]">
                Если Вы уже точно знаете, какие модели бункеров-перегрузчиков Вам
                нужны, выберите этот вариант
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
